import type { PropsWithChildren } from "react";

export const AppThemeProvider = ({ children }: PropsWithChildren) => {
	return <>{children}</>;
};
